import { ReactComponentManifest } from "web/entrypoints/common/setup";
// Components
import AdsenseDisplay from "web/react/components/adsense-display/adsense-display";
import AdsenseShopping from "web/react/components/adsense-shopping/adsense-shopping";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
import CcpaOption from "web/react/components/ccpa-option/ccpa-option";
import LeadLink from "web/react/components/lead-link/lead-link";
import RelatedProductsArea from "web/react/components/LEGACY_related-products-area/related-products-area";
import ProductCardSendToAppModal from "web/react/components/product-card-send-to-app-modal/product-card-send-to-app-modal";
import ProductsCarousel from "web/react/components/products-carousel/products-carousel";
import RecentlyViewed from "web/react/components/recently-viewed/recently-viewed";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import RetailerPromotionHub from "web/react/components/retailer-promotion-hub/retailer-promotion-hub";
import SaleLandingPageLayout from "web/react/components/sale-landing-page-layout/sale-landing-page-layout";
import TrendsLandingPageLayout from "web/react/components/trends-landing-page-layout/trends-landing-page-layout";
import UnsubscribeFeedback from "web/react/components/unsubscribe-feedback/unsubscribe-feedback";
import UnsubscribeOverlay from "web/react/components/unsubscribe-overlay/unsubscribe-overlay";
import AboutUsPage from "web/react/pages/about/about-us";
import PreSaleLandingShopPage from "web/react/pages/pre-sale/pre-sale-landing-shop-page";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    // Components
    AdsenseDisplay: withRedux(AdsenseDisplay),
    AdsenseShopping: withRedux(AdsenseShopping),
    BrandAdContainer,
    CcpaOption,
    ProductCardSendToAppModal: withRedux(ProductCardSendToAppModal),
    RelatedProductsArea,
    RelatedSearchesRail,
    ProductsCarousel,
    RetailerPromotionHub,
    RecentlyViewed,
    SaleLandingPageLayout,
    TrendsLandingPageLayout: withRedux(TrendsLandingPageLayout),
    UnsubscribeOverlay,
    UnsubscribeFeedback,
    LeadLink,
    AboutUsPage,
    PreSaleLandingShopPage,
};

export default components;
